import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

export default function WhatsAppButton() {
  const [isExpanded, setIsExpanded] = useState(false);
  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '917995659797';

  return (
    <div className="hidden lg:block fixed bottom-6 right-6 z-50">
      {/* Expanded Card */}
      <div
        className={`absolute bottom-16 right-0 w-72 bg-white rounded-2xl shadow-large overflow-hidden transition-all duration-300 ${
          isExpanded ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible translate-y-4'
        }`}
      >
        <div className="bg-[#25D366] p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                <MessageCircle className="w-5 h-5 text-[#25D366]" />
              </div>
              <div>
                <p className="text-white font-medium text-sm">Chat with us</p>
                <p className="text-white/80 text-xs">We reply instantly</p>
              </div>
            </div>
            <button
              onClick={() => setIsExpanded(false)}
              className="text-white/80 hover:text-white"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="p-4">
          <p className="text-text-secondary text-sm mb-4">
            Have questions about your interiors? Chat with our design experts now!
          </p>
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hi, I'm interested in Iravatham Interiors. Please share more details.`}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 bg-[#25D366] text-white rounded-xl font-medium hover:bg-[#20BD5C] transition-colors"
          >
            <MessageCircle className="w-5 h-5" />
            Start Chat
          </a>
        </div>
      </div>

      {/* Floating Button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className={`relative w-14 h-14 bg-[#25D366] rounded-full shadow-large flex items-center justify-center text-white hover:scale-110 transition-all duration-300 ${
          !isExpanded ? 'animate-pulse-soft' : ''
        }`}
        aria-label="Chat on WhatsApp"
      >
        {isExpanded ? (
          <X className="w-6 h-6" />
        ) : (
          <MessageCircle className="w-6 h-6" />
        )}
        {/* Notification dot */}
        {!isExpanded && (
          <span className="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full border-2 border-white" />
        )}
      </button>
    </div>
  );
}
